import { ValidationErrorResponse } from "../../../services/ValidationError";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    numeroSesiones: TextFormValue,
    precioTotal: TextFormValue,
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    numeroSesiones: { value: "0", wasTouched: false, isValid: undefined },
    precioTotal: { value: "0", wasTouched: false, isValid: undefined },
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}